import { gql } from "graphql-tag";

export const UPDATE_INTEREST = gql`
  mutation AdminUpdateInterest($id: ID!, $submittedAt: String, $userId: String) {
    adminUpdateInterest(id: $id, submittedAt: $submittedAt, userId: $userId) {
      id
    }
  }
`;

export const SEARCH_QUERY = gql`
  query adminSearchInterests(
    $email: String,
    $firstName: String,
    $lastName: String,
    $strict: Boolean,
    $includeIncomplete: Boolean
  ) {
    adminSearchInterests(
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      strict: $strict,
      includeIncomplete: $includeIncomplete
    ) {
      applicantEmail
      applicantPrimaryPhone
      applicantPrimaryPhoneType
      applicantSecondaryPhone
      applicantSecondaryPhoneType
      contactEmail
      contactName
      firstName
      hasAccount
      householdMember0Email
      id
      lastName
      linkCode
      loginEmail
      loginPhone
      mailingAddress1
      mailingSteNumber
      mailingCity
      mailingState
      mailingZip
      organizationName
      residenceAddress1
      residenceSteNumber
      residenceCity
      residenceState
      residenceZip
      submittedAt
      userId
      waitlistName
      waitlistStatus
      waitlistUpdateCode
      waitlistUpdateResponded
      waitlistUpdateRespondedAt
    }
  }
`;
